import { stringify } from 'qs';
import { useQuery } from '@tcs/common/hooks/useQuery';
import { Transaction } from '@tcs/client-portal-api/types/Transaction';

interface Props {
  loading: boolean;
  data?: Transaction[];
}

export const useAccountInvestmentTransactions = (
  accountNumber: string,
  assetCode: string,
  institutionCode: string
): Props => {
  const { data, isLoading: loading } = useQuery<Array<Transaction>, Error>(
    `/transactions/account/${accountNumber}/investmentTransactions?${stringify({
      assetCode,
      institutionCode,
    })}`,
    {
      refetchOnMount: false,
    }
  );

  return {
    loading,
    data,
  };
};

export const useAccountCashTransactions = (accountNumber: string): Props => {
  const { data, isLoading: loading } = useQuery<Array<Transaction>, Error>(
    `/transactions/account/${accountNumber}/cashTransactions`,
    {
      refetchOnMount: false,
    }
  );

  return {
    loading,
    data,
  };
};
